import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import * as R from 'ramda';
import { format } from 'date-fns';

import { SvgIcon } from '../../svg-icon';
import { getAvatarUrl } from '../../../utils';
import { TaskDropdownComp } from '../task-dropdown';
import { DropdownWithDots, Tooltip } from '../../popovers';

import {
  TaskWrapper,
  TaskResponsiblePerson,
  TaskTitleWrap,
  TaskRightSide,
  TaskLeftSide,
  TaskCenter,
  TaskDueDate,
  ImageWrapper,
  SmallDivider,
  AssignedUserImageWrap,
  ResponsibleUserFullName,
} from './styled-components';
import { theme } from '../../../styles';
import TaskPriority from '../../task-item/task-priority';
import { TASK_PRIORITIES } from '../../../api/constants';
import { AvatarImage } from '../../avatar/styled-components';

const Task = ({
  _id,
  title,
  status,
  dueDate,
  dueTime,
  subject,
  contacts,
  hideActions,
  assignedTo,
  requestId,
  taskPriority,
  openTaskModal,
  handleTaskUpdate,
  handleTaskDelete,
  handleTaskStatusUpdate,
}) => {
  const [showTaskDetails, setShowTaskDetails] = useState(false);
  const [editTask, setEditTask] = useState(false);

  const getTaskPriorityObject = priority => R.find(
    ({ value }) => value === priority,
    TASK_PRIORITIES,
  );

  return (
    <TaskWrapper>
      <TaskLeftSide>
        {!hideActions &&
        <React.Fragment>
          <Tooltip
            placement="bottomLeft"
            title={status ? 'Done' : 'In progress'}
          >
            <ImageWrapper>
              <SvgIcon
                transform="scale(0.8)"
                type={status ? 'done' : 'inProgress'}
                onClick={() => handleTaskStatusUpdate(_id, !status)}
                color={status ? theme.colors.fontTangerine : theme.colors.lightDark}
              />
            </ImageWrapper>
          </Tooltip>

          <SmallDivider type="vertical" />

          <Tooltip
            title="View more..."
            placement="bottomLeft"
            visible={showTaskDetails}
            onVisibleChange={setShowTaskDetails}
          >
            <ImageWrapper>
              <SvgIcon
                type="viewDetails"
                fillOpacity={0.5}
                onClick={() => {
                  openTaskModal(_id, requestId);
                  setShowTaskDetails(false);
                }}
              />
            </ImageWrapper>
          </Tooltip>

          <SmallDivider type="vertical" />
        </React.Fragment>}

        <TaskPriority
          priority={getTaskPriorityObject(taskPriority)}
          withTitle={false}
          withMargin={false}
        />

        <SmallDivider type="vertical" />

        <Tooltip
          title="Edit"
          visible={editTask}
          onVisibleChange={setEditTask}
        >
          <ImageWrapper>
            <SvgIcon
              type="pencil"
              onClick={() => {
                handleTaskUpdate(_id, requestId);
                setEditTask(false);
              }}
            />
          </ImageWrapper>
        </Tooltip>

        <SmallDivider type="vertical" />

        <Tooltip
          title={title}
          placement="bottomLeft"
        >
          <TaskTitleWrap done={status}>
            {title}
          </TaskTitleWrap>
        </Tooltip>
      </TaskLeftSide>

      <TaskCenter>
        <Tooltip title="Due date">
          <TaskDueDate done={status}>
            {format(dueDate, 'd MMM yyyy')}
            {dueTime && ` ${format(dueTime, 'HH:mm')}`}
          </TaskDueDate>
        </Tooltip>
      </TaskCenter>

      <TaskRightSide>
        {!R.isEmpty(assignedTo) ? (
          <Tooltip title="Responsible user">
            <TaskResponsiblePerson>
              <ResponsibleUserFullName>
                {assignedTo.fullName}
              </ResponsibleUserFullName>

              <AssignedUserImageWrap>
                <AvatarImage
                  width={24}
                  height={24}
                  src={getAvatarUrl(assignedTo.profileImage)}
                />
              </AssignedUserImageWrap>
            </TaskResponsiblePerson>
          </Tooltip>
        ) : (
          <Tooltip title="Responsible user">
            <TaskResponsiblePerson>
              <ResponsibleUserFullName>Unassigned</ResponsibleUserFullName>

              <AssignedUserImageWrap>
                <SvgIcon type="anonymous" />
              </AssignedUserImageWrap>
            </TaskResponsiblePerson>
          </Tooltip>
        )}

        <DropdownWithDots
          overlay={TaskDropdownComp({
            _id,
            title,
            subject,
            contacts,
            requestId,
            hideActions,
            handleTaskUpdate,
            handleTaskDelete,
          })}
        />
      </TaskRightSide>
    </TaskWrapper>
  );
};

Task.propTypes = {
  _id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.bool.isRequired,
  dueDate: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  contacts: PropTypes.array,
  hideActions: PropTypes.bool,
  dueTime: PropTypes.string,
  assignedTo: PropTypes.object,
  requestId: PropTypes.string.isRequired,
  taskPriority: PropTypes.string.isRequired,
  openTaskModal: PropTypes.func.isRequired,
  handleTaskUpdate: PropTypes.func.isRequired,
  handleTaskDelete: PropTypes.func.isRequired,
  handleTaskStatusUpdate: PropTypes.func.isRequired,
};

Task.defaultProps = {
  assignedTo: {},
  dueTime: undefined,
  contacts: [],
  hideActions: false,
};

export default Task;



// WEBPACK FOOTER //
// ./src/components/tasks-list/task/index.js